import { z } from "zod";
export const farmOverviewDetailDtoSchema = z.object({
    farmLicenseKey: z.string(),
    isoWeekStartDate: z.string(),
    customerNumber: z.string().nullable(),
    customerName: z.string().nullable(),
    adviceCount: z.number(),
    farmScore: z.number(),
    visitBehaviorScore: z.number(),
    preTreatmentScore: z.number(),
    attachmentScore: z.number(),
    startMilkingScore: z.number(),
    peakMilkingScore: z.number(),
    endMilkingScore: z.number(),
    postTreatmentScore: z.number(),
});
export const farmOverviewDtoSchema = z.object({
    farmLicenseKey: z.string(),
    isoWeekStartDate: z.string(),
    adviceCount: z.number(),
    farmScore: z.number(),
    customerNumber: z.string().nullable(),
    customerName: z.string().nullable(),
});
//# sourceMappingURL=farm.schema.js.map